import React from 'react'

import { useTheme, styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { getCurrentDate } from 'constants/index'

import ConnectButton from 'components/Common/Button/ConnectButton'
import SectionTitle from 'components/Common/SectionTitle'
import ToolTip from 'components/Common/ToolTip'

import routes from 'routes'
import { useNavigate } from 'react-router-dom'

const CardHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

const CardBody = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const SalesCard = props => {
  const theme = useTheme()

  const navigate = useNavigate()

  const handleClickConnect = e => {
    e && e.preventDefault()
    navigate(routes.goldenRecord)
  }

  const tooltipContent = (
    <Typography variant="body2" color="white">
      Review the businesses in your portfolio with bespoke golden records.
    </Typography>
  )

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          padding: '25px',
        }}
      >
        <CardHeader>
          <Box>
            <SectionTitle title="Your Golden Records" />
            &nbsp;
            <ToolTip content={tooltipContent} />
          </Box>
          <Box sx={{ display: 'flex' }}></Box>
        </CardHeader>
        <Typography
          component="div"
          variant="overline1"
          sx={{
            float: 'left',
            color: theme.palette.color.darkBlue50,
            marginTop: '8px',
          }}
        >
          DAILY - {getCurrentDate()}
        </Typography>

        <CardBody>
          <Box
            sx={{
              flex: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              position: 'relative',
              alignItems: 'center',
            }}
          >
            <Box marginTop="30px">
              <Typography variant="body1M" color="primary">
                Total Golden Records:
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  textAlign: 'center',
                  color: theme.palette.color.blueLight,
                }}
              >
                {'1,537'}
              </Typography>
            </Box>

            <Box>
              <Typography variant="body1M" color="primary">
                Number of Adjusted Fields:
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  textAlign: 'center',
                  color: theme.palette.color.aqua110,
                }}
              >
                {'2,981'}
              </Typography>
            </Box>
          </Box>

          <ConnectButton onClick={handleClickConnect} label="Manage Your Golden Records" />
        </CardBody>
      </Box>
    </Box>
  )
}

export default SalesCard
